import { rem } from 'polished';
import styled from 'styled-components';
import { CheckoutPreOrderStyled } from '../CheckoutPreOrderStyled';

export const CheckoutPreOrderStyledOV = styled(CheckoutPreOrderStyled)`
    font-family: ${({ theme }) => theme.fonts.fontSecondary};

    .subTitle {
        font-family: ${({ theme }) => theme.fonts.fontSecondary};
        font-size: ${rem('16px')};
    }
    .summaryRow {
        color: ${({ theme }) => theme.colors.black};
    }
    .wrapper-cols {
        flex: unset;
    }
    .submitButton button {
        margin-top: ${rem('30px')};
        font-weight: ${({ theme }) => theme.fontWeights.textMedium};
    }

    .cashPaymentRejectedWrapper {
        &_button {
            color: ${({ theme }) => theme.colors.black};
            font-weight: bold;

            &:hover {
                background: ${({ theme }) => theme.colors.black};
                color: ${({ theme }) => theme.colors.white};
            }
        }
    }
`;
